/**
 * @param {Draft.EditorState} editorState
 */
export function isEmptyContent(editorState) {
	const content = editorState.getCurrentContent();
	const blocks = content.getBlocksAsArray();
	if (blocks.length > 1) {
		return false;
	}
	return blocks[0].getType() === 'unstyled' && !blocks[0].getText();
}



// WEBPACK FOOTER //
// ./lib/helpers/isEmptyContent.js